import React from 'react'
import { ModalRoutingContext } from 'gatsby-plugin-modal-routing'

import Components from './../components/Components'
import Header from '../components/Header/Header'
import Footer from './../components/Footer'
import PopupModal from './../components/PopupModal'
import Member from './../components/Member'

class StoryblokEntry extends React.Component {
	
	static getDerivedStateFromProps(props, state) {
		if (state.story.uuid === props.pageContext.story.uuid) {
			return null
		}

		return StoryblokEntry.prepareStory(props)
	}

	static prepareStory(props) {

		const story = Object.assign({}, props.pageContext.story)
		const theme = Object.assign({}, props.pageContext.theme)
		const popup = props.location.state

		story.content = JSON.parse(story.content)
		theme.content = JSON.parse(theme.content)
		
		return { story, theme, popup }
	}

	constructor(props) {
		super(props)

		this.state = StoryblokEntry.prepareStory(props)
	}

	render() {

        let content = this.state.story.content
		let theme = this.state.theme.content
        let popup = this.state.popup

		return (
            <ModalRoutingContext.Consumer>
                {({ modal, closeTo }) => {
                    return (
                        <>
                            {modal ? (
                                <PopupModal
                                    blok={popup && popup.content}
                                    closeTo={closeTo}
                                />
                            ) : (
                                <>
                                    <Header blok={theme} banner={{ color: content.banner_color }}/>
                                    {content.component == 'member' ? <Member blok={content} /> : React.createElement(Components(content.component), {key: content._uid, blok: content})}
                                    <Footer blok={theme} />
                                </>
                            )}
                        </>
                    )
                }}
            </ModalRoutingContext.Consumer>
		)
	}
}

export default StoryblokEntry
